import React, {
  FunctionComponent,
  useContext,
  useState,
  useEffect,
} from 'react'
import { AiFillSetting } from 'react-icons/ai'
import { FiSearch } from 'react-icons/fi'
import { MdClose } from 'react-icons/md'

import '../styles/SearchBar.scss'
import { useSearchQuery, useInstantSearch } from '../App'
import { ENTER_KEY } from '../utils/constants'
import Icon from './Icon'
import Filter from './Filter'
import Sort from './Sort'
import Settings from './Settings'

const SearchBar: FunctionComponent = () => {
  const { variable: searchQuery, setVariable: setSearchQuery } = useContext(
    useSearchQuery
  )!
  const { variable: instantSearch } = useContext(useInstantSearch)!
  const [showMenu, toggleMenu] = useState(false)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === ENTER_KEY) {
      const { value } = e.target as HTMLInputElement
      setSearchQuery(value.toLowerCase())
    }
  }

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>
    const input = document.getElementById('search-bar') as HTMLInputElement

    const handleInstantSearch = function () {
      timeout = setTimeout(() => {
        if (input.value !== searchQuery) {
          setSearchQuery(input.value)
        }
      }, instantSearch.delay * 1000)
    }

    if (!instantSearch.isOn) return

    input.addEventListener('keyup', handleInstantSearch, true)

    return () => {
      clearTimeout(timeout)
      input.removeEventListener('keyup', handleInstantSearch, true)
    }
  })

  const handleClick = () => {
    const input = document.getElementById('search-bar') as HTMLInputElement

    if (input) {
      setSearchQuery(input.value)
    }
  }

  return (
    <>
      <div className='SearchBar'>
        <div className='SearchBar-input'>
          <Icon
            icon={FiSearch}
            backgroundColor='transparent'
            clickFunction={handleClick}
          />
          <input onKeyDown={(e) => handleKeyDown(e)} id='search-bar'></input>
        </div>

        <div className='SearchBar-rightActions'>
          {showMenu ? (
            <Icon
              icon={MdClose}
              backgroundColor='#c2c8d6'
              clickFunction={() => toggleMenu((showMenu) => !showMenu)}
            />
          ) : (
            <Icon
              icon={AiFillSetting}
              backgroundColor='#eff4f7'
              clickFunction={() => toggleMenu((showMenu) => !showMenu)}
            />
          )}
        </div>
      </div>
      {showMenu && (
        <div className='SearchBar-filter'>
          <Filter />
          <Sort />
          <Settings />
        </div>
      )}
    </>
  )
}

export default SearchBar
